
import useService from "services/auth";
import useAuthProvider from "./useAuthProvider";
import useClearAllAtoms from "./useResetAtom";

const useLogout =()=>{
    const service = useService();
    const clearAllAtoms = useClearAllAtoms();
    const authProvider = useAuthProvider();
    const logout = async () => {
        try { await service.logout(); } catch { /* server errors must not block local logout */ }
        authProvider.clearTokens();
        clearAllAtoms();
    };
    return logout;
}

export default useLogout;